import React from 'react';
import CountUp from 'react-countup';

const FunFact = (props) => {
    const numberStyle = {
        fontSize: "clamp(48px, 8vw, 100px)", // responsive up to 100px
        fontWeight: 900,
        lineHeight: 1,
    };

    const labelStyle = {
        fontSize: "clamp(13px, 1.6vw, 16px)",
        letterSpacing: "1px",
        marginTop: "6px",
    };

    return (
        <section className={props.hclass}>
            <div className="container-fluid">
                <div className="row">

                    {/* HOMES DESIGNED */}
                    <div className="col-lg-3 col-md-6 col-12 fade_bottom">
                        <div className="item">
                            <h2 style={numberStyle}>
                                <span><CountUp end={15} enableScrollSpy /></span>
                                <span className="icon">+</span>
                            </h2>
                            <h3 style={labelStyle}>HOMES DESIGNED</h3>
                        </div>
                    </div>

                    {/* ONGOING PROJECTS */}
                    <div className="col-lg-3 col-md-6 col-12 fade_bottom">
                        <div className="item">
                            <h2 style={numberStyle}>
                                <span><CountUp end={8} enableScrollSpy /></span>
                                <span className="icon">+</span>
                            </h2>
                            <h3 style={labelStyle}>ONGOING PROJECTS</h3>
                        </div>
                    </div>

                    {/* YEAR WE STARTED */}
                    <div className="col-lg-3 col-md-6 col-12 fade_bottom">
                        <div className="item">
                            <h2 style={numberStyle}>
                                <span>100%</span>
                            </h2>
                            <h3 style={labelStyle}>QUALITY ASSURED</h3>
                        </div>
                    </div>

                    {/* HAPPY CLIENTS */}
                    <div className="col-lg-3 col-md-6 col-12 fade_bottom">
                        <div className="item">
                            <h2 style={numberStyle}>
                                <span><CountUp end={20} enableScrollSpy /></span>
                                <span className="icon">+</span>
                            </h2>
                            <h3 style={labelStyle}>HAPPY CLIENTS</h3>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default FunFact;
